import React from 'react';

function InfoIcon() {
  const containerStyle = {
    display: 'inline-block',
    position: 'relative',
    margin: 'auto',
    verticalAlign: 'middle'
  };
  const pathStyle = {
    fill: '#333333'
  };
  return (
    <span className="info-icon" style={containerStyle}>
      <svg version="1.1"
           id="Layer_2"
           xmlns="http://www.w3.org/2000/svg"
           viewBox="0 0 1792 1792"
           width="25" height="25">
          <path className="st0" style={pathStyle} d="M1152,1376v-160c0-9.3-3-17-9-23s-13.7-9-23-9h-96V672c0-9.3-3-17-9-23s-13.7-9-23-9H672c-9.3,0-17,3-23,9
	s-9,13.7-9,23v160c0,9.3,3,17,9,23s13.7,9,23,9h96v320h-96c-9.3,0-17,3-23,9s-9,13.7-9,23v160c0,9.3,3,17,9,23s13.7,9,23,9h448
	c9.3,0,17-3,23-9S1152,1385.3,1152,1376z M1024,480V320c0-9.3-3-17-9-23s-13.7-9-23-9H800c-9.3,0-17,3-23,9s-9,13.7-9,23v160
	c0,9.3,3,17,9,23s13.7,9,23,9h192c9.3,0,17-3,23-9S1024,489.3,1024,480z M1664,896c0,139.3-34.3,267.8-103,385.5
	s-161.8,210.8-279.5,279.5s-246.2,103-385.5,103s-267.8-34.3-385.5-103S299.7,1399.2,231,1281.5S128,1035.3,128,896
	s34.3-267.8,103-385.5S392.8,299.7,510.5,231S756.7,128,896,128s267.8,34.3,385.5,103s210.8,161.8,279.5,279.5S1664,756.7,1664,896z
	"/>
  </svg>
    </span>
  );
}

export default InfoIcon;



/** WEBPACK FOOTER **
 ** ./src/components/icons/InfoIcon.js
 **/